import { Component, EventEmitter, Input, Output } from "@angular/core";

@Component({
  selector: "app-status-summary-card",
  imports: [],
  templateUrl: "./status-summary-card.component.html",
  styleUrl: "./status-summary-card.component.scss",
})
export class StatusSummaryCardComponent {
  @Input({ required: true }) label!: string;
  @Input({ required: true }) count!: number;
  @Input({ required: true }) colorVariant!: string;
  @Input() active = false;
  @Output() cardClick = new EventEmitter<void>();
}
